import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import DropDown from "../../../sharedComponents/dropDown/dropDown";
import { TypeOfActivityDropDown, TypeOfActivityId } from "../../../../helpers/additionalQuestions/typeOfActivity";
import Notification from "../../../sharedComponents/notification/notification";
import { CalculationService } from "../../../../services/services/calculationService";

interface TypeOfActivityProps {
    calculateStore?: CalculateStore;
    calculationService?: CalculationService;
}

export function TypeOfActivity(props: TypeOfActivityProps) {
    const calculateStore = props.calculateStore!;
    const value = calculateStore.additionalQuestions.typeOfActivity;

    function onChange(val: TypeOfActivityId) {
        calculateStore.setTypeOfActivity(val);
        props.calculationService!.setRisksNetworkForAllPackages();
    }

    return (
        <div className="additional-questions-section type-of-activity">
            <div className="question-answer-container">
                <div className="question">{TypeOfActivityDropDown.label}</div>
                <DropDown onChange={(val) => {
                    onChange(val);
                }}
                    value={value as string}
                    items={TypeOfActivityDropDown.dropDown}
                />
            </div>
            <div>
                {isUnavailableOptionSelected()
                    && <Notification type="error" message="Niestety dla wybranego rodzaju działalności nie przedstawimy oferty. Zapoznaj się z naszą ofertą ubezpieczenia Bezpieczny Przedsiębiorca. " />}
            </div>
        </div>
    );

    function isUnavailableOptionSelected() {
        switch (value) {
            case TypeOfActivityId.agricultural:
            case TypeOfActivityId.registered:
            case TypeOfActivityId.retailTrade:
            case TypeOfActivityId.services:
                return false;
            default:
                return true;
        }
    }
}

export default inject("calculateStore", "calculationService")(observer(TypeOfActivity));
